import en from './en';
import ptBR from './pt-BR';
import es from './es';

export const translations = {
  en,
  'pt-BR': ptBR,
  es,
};

export default translations;
